export default __webpack_public_path__ + "static/media/hzzz.0e3e5534.png";